import { WORK_ORDER_STATUS } from 'settings/constants/service'

const {
  SCHEDULED,
  IN_PROCESS,
  SKIPPED,
  CANCELED,
  SERVICED,
  HOLD,
  MIXED,
  INCOMPLETE,
  MIXED_INCOMPLETE,
  PARTIALLY_SERVICED,
  PARTIALLY_SKIPPED,
} = WORK_ORDER_STATUS

export const WORK_ORDER_STATUS_FILTER_MENU_OPTIONS = [
  { id: SCHEDULED, value: SCHEDULED },
  { id: IN_PROCESS, value: IN_PROCESS },
  { id: SKIPPED, value: SKIPPED },
  { id: CANCELED, value: CANCELED },
  { id: SERVICED, value: SERVICED },
  { id: HOLD, value: HOLD },
  { id: MIXED, value: PARTIALLY_SERVICED },
  { id: MIXED_INCOMPLETE, value: `${PARTIALLY_SERVICED} (incomplete)` },
  { id: INCOMPLETE, value: PARTIALLY_SKIPPED },
]

export const WORK_ORDER_STATUS_IDS = WORK_ORDER_STATUS_FILTER_MENU_OPTIONS.map(({ id }) => id)
